export enum FormField {
  Text = "text",
  Textarea = "textarea",
  Image = "image",
  File = "file",
  Number = "number",
  Radio = "radio",
  Checkbox = "checkbox",
  ArrayOfFields = "arrayOfFields",
  Select = "select",
  TenantSelect = "tenantSelect",
  Dropdown = "dropdown",
  DateTime = "datetime",
  DateOnly = "dateonly",
  TimeOnly = "timeonly",
  Calendar = "calendar",
  User = "user",
  Relation = "relation",
  MultipleRelation = "multiplerelation",
  SystemRelation = "systemrelation",
  RichText = "richtext",
  Instruction = "instruction",
  Hidden = "hidden",
  Code = "code",
  Gpx = "gpx",
  MenuIcon = "menuIcon",
}
